import { store } from '../store/appStore';
import { exportProject3mf, shareOrDownload3mf } from './project3mf';
import { capturePlateThumbnail } from '../scene/PlateViewer';
import { findFilamentPreset, findPrinterPreset, findProcessPreset, loadUserPresets } from '../settings/presets';
import { toast } from '../ui/toast';

export async function runExport(): Promise<boolean> {
  const snap = store.getSnapshot();
  if (!snap.objects.length) {
    toast('Add a model first');
    return false;
  }
  toast('Building project 3MF…', 4000);
  try {
    const tpl = await fetch('/bambu/project_settings.config').then((r) => r.text());
    const thumb = await capturePlateThumbnail();
    const users = loadUserPresets();
    const proc = findProcessPreset(snap.processPresetId, users);
    const fil = findFilamentPreset(snap.filamentPresetId, users);
    const printer = findPrinterPreset(snap.printerPresetId);
    const data = exportProject3mf({
      projectSettingsText: tpl,
      settings: snap.settings,
      objects: snap.objects,
      projectName: snap.projectName,
      thumbnailPng: thumb,
      printSettingsId: proc?.name,
      filamentSettingsId: fil?.name,
      printerSettingsId: printer?.name,
    });
    const name = `${store.getSnapshot().projectName || 'project'}.3mf`;
    const how = await shareOrDownload3mf(data, name);
    toast(how === 'shared' ? 'Shared via system sheet' : `Downloaded ${name}`);
    return true;
  } catch (e) {
    if ((e as Error).name !== 'AbortError') toast(`Export failed: ${(e as Error).message}`);
    return false;
  }
}
